module.exports = __webpack_public_path__ + "img/ring.564dd28e.webp";